import { v4 } from 'uuid';

import { adjustmentType, SkuType } from './enums';
import { PromotionalItemData } from './data/promotion-sku-assets.class';
import { RecordData } from '../../helpers-classes';
import { PromotionalSkuData, PromotionalSkuDataIn } from './types';

type PromotionalSkuDataResponse = PromotionalSkuData;
export const promotionalSkuData = (dataIn: PromotionalSkuDataIn = null): PromotionalSkuDataResponse => {
	const rd = new RecordData<PromotionalSkuDataIn>(dataIn);
	const assetData = dataIn?.sku ? PromotionalItemData.findBySku(dataIn.sku) : null;

	const record: PromotionalSkuDataResponse = {
		id: rd.useNewOrPartial<string>('id', v4()),
		sku: dataIn?.sku ?? null,
		description: rd.useNewOrDefault<string | null>('description', assetData?.description ?? null),
		priceAdjustment: rd.useNewOrDefault<number>('priceAdjustment', assetData?.priceAdjustment ?? 0),
		adjustmentType: rd.useNewOrDefault('adjustmentType', assetData?.adjustmentType ?? adjustmentType.Fixed),
		skuType: rd.useNewOrDefault('skuType', assetData?.skuType ?? SkuType.Promotion),
		requiredSkus: rd.useNewOrDefault<string[]>('requiredSkus', assetData?.requiredSkus ?? null),
		discountRules: rd.useNewOrDefault('discountRules', assetData?.discountRules ?? []),
		hsProductId: rd.useNewOrDefault<string | null>('hsProductId', assetData?.hsProductId ?? null),
		quantity: rd.useNewOrDefault<number>('quantity', 1)
	};

	return record;
};
